import { render, staticRenderFns } from "./CompanyRiskDialog.vue?vue&type=template&id=3ff4fd26&scoped=true"
import script from "./CompanyRiskDialog.vue?vue&type=script&lang=js"
export * from "./CompanyRiskDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyRiskDialog.vue?vue&type=style&index=0&id=3ff4fd26&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff4fd26",
  null
  
)

export default component.exports